import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StudyAreaStatus } from '../../enums/study-area-status';
import { StudyAreaCommentRequest } from '../../interfaces/study-area';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-study-area-comment-modal',
  templateUrl: './study-area-comment-modal.component.html',
  styleUrl: './study-area-comment-modal.component.scss',
})
export class StudyAreaCommentModalComponent implements OnInit, OnDestroy {
  contentMaxLength: number = 150;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}
  StudyAreaStatus = StudyAreaStatus;

  ngOnInit(): void {
    this.model = this.config.data;
    this.projectDirectoryLinkClicked$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        window.open(
          'https://apex.stantec.com/apex/r/ibautil/project-directory/project-directory',
          '_blank',
          'noopener'
        );
      });
  }

  private ngUnsubscribe = new Subject<void>();
  private projectDirectoryLinkClicked$ = new Subject<{
    field: FormlyFieldConfig;
    event: Event;
  }>();

  billingFields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'p-d-flex basin-pb-2',
      fieldGroup: [
        {
          key: 'projectCode',
          className:
            'basin-mb-4 basin-mr-4 basin-md-mb-0 basin-width-100 basin-md-width-50 basin-font-size-16 basin-font-weight-400 basin-color-mid-gray',
          type: 'textbox',
          props: {
            label: 'Project Code',
            type: 'string',
            required: true,
            description:
              "To access Oracle information via Stantec's Project Directory, click here.",
            actionDescription: true,
            actionDescriptionClicked: this.projectDirectoryLinkClicked$,
          },
        },
        {
          key: 'invoiceId',
          className:
            'basin-width-100 basin-md-width-50 basin-mb-0 basin-font-size-16 basin-font-weight-400 basin-color-mid-gray',
          type: 'textbox',
          props: {
            label: 'Invoice ID',
            type: 'string',
            required: false,
          },
        },
      ],
    },
  ];

  maxLengthExceeded: boolean = false;
  form: FormGroup = new FormGroup({});
  model?: StudyAreaCommentRequest;
  fields: FormlyFieldConfig[] = [
    {
      className: 'basin-width-100',
      key: 'content',
      id: 'content',
      type: 'textarea',
      props: {
        label: 'Description',
        type: 'string',
        maxLength: this.contentMaxLength,
        change: (field: FormlyFieldConfig) => {
          const control: any = field.formControl;
          if (control) {
            this.maxLengthExceeded =
              control.value.length > this.contentMaxLength;
          }
        },
      },
    },
  ];

  cancel() {
    this.ref.close();
  }

  accept(model?: StudyAreaCommentRequest) {
    if (!this.form.dirty) {
      this.form.markAllAsTouched();
      return;
    }

    this.ref.close({ request: model });
  }

  isSaveDisabled(model?: StudyAreaCommentRequest): boolean {
    if (!this.form.dirty)
      return true;

    if (this.config.data.status !== StudyAreaStatus.Paid && (model?.content === undefined || model?.content === ""))
      return true;
    if (model?.content != null && model?.content.length > this.contentMaxLength)
      return true;

    return false;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
